module.exports = __webpack_public_path__ + "img/sweiper_img.f964105a.png";